import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'
import { ModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { multilingualServiceDS } from './multilingualService'
import { MultilingualServiceSideEffects } from './multilingualServiceSideEffects'

export const editor: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(multilingualServiceDS)
	bind(ModelUpdatesHandlersImplementor).to(MultilingualServiceSideEffects)
}
